import { ReactNode } from "react"
import cn from "classnames"

import style from "components/EmojiTag/style.module.scss"
import { Text } from "ui-kit/components-branded/Text"

interface EmojiTagProps {
    children: ReactNode
    emoji?: string
    imgLink: string
    className?: string
}

export function EmojiTag({ children, imgLink, className }: EmojiTagProps) {
    return (
        <span className={cn(style.container, className)}>
            <Text isAccent>{children}</Text>
            <img className={style.image} src={imgLink} alt="" />
        </span>
    )
}
